import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  negTop: {
    marginTop: '-5rem'
  },

  posTop: {
    marginTop: '2rem'
  },

  buttonWhite: {
    marginTop: '2rem',
    color: 'white'
  },

  icon: {
    display: 'flex',
    width: '6.6rem',
    height: '6.6rem',
    marginLeft: '1rem'
  },

  titleText: {
    fontSize: '30px',
    color: '#041854',
    [theme.breakpoints.only('xs')]: {
      color: 'white'
    }
  },

  colorMargins: {
    padding: '2rem',
    color: '#041854',
    [theme.breakpoints.only('xs')]: {
      backgroundColor: '#041854',
      color: 'white'
    }
  },

  txtField: {
    height: 30,
    backgroundColor: 'white',
    borderRadius: 6
  },

  txtInfo: {
    color: 'grey',
    [theme.breakpoints.only('xs')]: {
      color: 'white'
    }
  },

  topFields: {
    marginTop: '1rem',
    [theme.breakpoints.only('xs')]: {
      marginTop: '3rem'
    }
  },

  topFields2: {
    marginTop: '1rem',
    [theme.breakpoints.only('xs')]: {
      marginTop: 0
    }
  },

  profileCheck: {
    marginBottom: '3rem'
  },

  colorChange: {
    marginLeft: '0.3rem',
    color: '#041854',
    [theme.breakpoints.only('xs')]: {
      backgroundColor: '#041854',
      color: 'white'
    },
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: '#f77c2e'
    }
  }
}));

export default useStyles;
